<template>
  <div class="lazy-img" :style="customStyle" ref="lazyImg">
    <div ref="padding" class="padding" :style="customStyle">
      <img
        :src="GLOBAL_default_seat"
        :width="paddingImgWidth"
        alt="图片占位图"
      />
    </div>
    <div
      ref="targetImg"
      class="lazy-img-wrap"
      :style="[
        ...customStyle,
        isRenderGroundGlassBgImg && { backgroundColor: 'transparent' },
      ]"
    >
      <img
        :class="imgClass"
        v-lazyload="lazyloadOptions"
        src="主图"
        :style="{ 'object-fit': mode || 'initial' }"
      />

      <div class="glass-effect-img-wrapper" v-if="isRenderGroundGlassBgImg">
        <img
          class="glass-effect-img"
          :src="src"
          alt="毛玻璃效果背景图片"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { checkWebp, isElmInView } from "../util/function.js";
import _ from "underscore";

const clientW = document.body.clientWidth;
export default {
  name: "lazy-img",
  props: {
    width: String,
    height: String,
    src: String,
    defaultImgWidth: {
      // 当需要的 padding 宽度小于 64px 时才需要设置
      type: String,
      default: "64px",
    },
    background: {
      type: String,
      default: "#f9f9f9",
    },
    borderRadius: {
      type: String,
      default: "8px",
    },
    //图片的裁切模式。可选值的css属性 object-fit 中
    mode: {
      type: String,
      validator(value) {
        const validValueList = [
          "fill", //默认，不保证保持原有的比例，内容拉伸填充整个内容容器
          "contain", //保持原有尺寸比例。内容被缩放。
          "cover", //保持原有尺寸比例。但部分内容可能被剪切。
          "none", //保留原有元素内容的长度和宽度，也就是说内容不会被重置。
          "scale-down", //保持原有尺寸比例。内容的尺寸与 none 或 contain 中的一个相同，取决于它们两个之间谁得到的对象尺寸会更小一些。
          "initial", //设置为默认值
          "inherit", //从该元素的父元素继承属性
        ];

        return validValueList.includes(value);
      },
    },
    // 是否显示毛玻璃背景图片
    showGroundGlassBgImg: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      paddingImgWidth: this.defaultImgWidth,
      canLoad: false,
      isRenderGroundGlassBgImg: false, //是否渲染毛玻璃背景图
    };
  },

  computed: {
    imgClass() {
      return ["target-img", this.class || ""];
    },
    customStyle() {
      return [
        { width: this.width },
        { height: this.height },
        { background: this.background },
        { borderRadius: this.borderRadius },
      ];
    },
    lazyloadOptions() {
      // 设置是否显示毛玻璃背景图片
      this.setIsRenderGroundGlassBgImg();

      return {
        src: this.rewriteLink(this.src),
        callback: this.onload,
      };
    },
  },
  methods: {
    onload() {
      const paddingEl = this.$refs.padding;
      const imgEl = this.$refs.targetImg;
      fadeInOut(imgEl, paddingEl);
    },
    rewriteLink(link) {
      const aliyunCDN = /\.maizuo\.com/;
      const w = this.getRewriteW();
      if (w && aliyunCDN.test(link)) {
        // 加压缩参数
        // 加格式参数，转成webp
        if (checkWebp()) {
          return this.addOssImgParams(link, ["format,webp"]);
        }
        return this.addOssImgParams(link, [`resize,w_${w}`]);
        // if (link.indexOf('?') !== -1) {
        //   link = `${link}&x-oss-process=image/resize,w_${w}`
        // } else {
        //   link = `${link}?x-oss-process=image/resize,w_${w}`
        // }
      }
      return link;
    },
    /* @param  Array[string]  */
    addOssImgParams(link, param) {
      if (link.indexOf("?") !== -1) {
        return `${link}&x-oss-process=image/${param.join("/")}`;
      }
      return `${link}?x-oss-process=image/${param.join("/")}`;
    },
    getRewriteW() {
      let w = this.width || "100%";
      if (w.indexOf("px") > 0) {
        w = w.substring(0, w.length - 2);
      } else if (w.indexOf("vw") > 0) {
        w = (w.substring(0, w.length - 2) * clientW) / 100;
      } else if (w.indexOf("%") > 0) {
        w = (w.substring(0, w.length - 1) * clientW) / 100;
      } else {
        return undefined;
      }
      return Math.round(1.5 * w);
    },
    /**
     * @feat <设置是否显示毛玻璃背景图片>
     * @describe < 只有当 src 加载出来得图片的长宽比widthHeightRatio !== 1 时，才显示背景毛玻璃背景效果 >
     */
    setIsRenderGroundGlassBgImg() {
      if (this.showGroundGlassBgImg === false) return;

      const newImg = new Image();

      newImg.src = this.src;
      newImg.onload = () => {
        const widthHeightRatio = newImg.width / newImg.height;

        if (widthHeightRatio !== 1) {
          this.isRenderGroundGlassBgImg = true;
        }
      };
    },
  },
  directives: {
    lazyload: {
      bind: (el, binding) => {
        if (!binding.value.src) {
          return;
        }
        // 如果没有初始化过，就初始化事件
        if (!window.lazyImgsWaiting) {
          // 初始化散列表
          window.lazyImgsWaiting = {};
          // 初始化事件
          window.onscroll = () => {
            const keys = Object.keys(window.lazyImgsWaiting);
            // 遍历正在等待加载的每一张图片
            keys.forEach((k) => {
              const cpList = window.lazyImgsWaiting[k];

              // 使用同一个图片的多个组件,只有有一个满足条件，就全部加载
              const imgShouldLoad = _.find(cpList, (cp) => isElmInView(cp.el));

              // 如果有需要加载
              if (imgShouldLoad) {
                const imgUrl = k;
                cpList.forEach((cp) => {
                  cp.el.src = imgUrl;
                  cp.value.callback();
                });

                // 加载完便将改图片从表中删除
                delete window.lazyImgsWaiting[k];
              }
            });
          };
        }
      },
      inserted: (el, binding) => {
        lazyImgAction(el, binding);
      },
      componentUpdated: (el, binding) => {
        // 当图片更新的时候

        if (binding.value.src === binding.oldValue.src) {
          return;
        }
        if (binding.oldValue.src) {
          // 如果有旧图片地址，要先删掉对应的监听
          const key = binding.oldValue.src;
          delete window.lazyImgsWaiting[key];
        }
        lazyImgAction(el, binding);
      },
      unbind: (el, binding) => {
        const key = binding.value.src;
        if (window.lazyImgsWaiting && window.lazyImgsWaiting[key]) {
          delete window.lazyImgsWaiting[key];
        }
      },
    },
  },
};

const lazyImgAction = (el, binding) => {
  // 如果初始化的时候已经在视野内，直接开始加载
  // setTimeout(() => {
  if (!binding.value.src) {
    return;
  }
  if (isElmInView(el)) {
    el.src = binding.value.src;
    binding.value.callback();
    return;
  }
  // 如果还不能加载，存到散列表
  // 用图片地址作为key
  const imgKey = binding.value.src;
  if (window.lazyImgsWaiting[imgKey]) {
    // 如果有多个组件用到同一张图, 所以使用数组
    window.lazyImgsWaiting[imgKey].push({
      el,
      value: binding.value,
    });
  } else {
    window.lazyImgsWaiting[imgKey] = [
      {
        el,
        value: binding.value,
      },
    ];
  }
  // }, 0);
};
function fadeInOut(newElm, oldEl) {
  if (!newElm) {
    return;
  }
  newElm.style.opacity = 0;
  newElm.style.display = "block";
  (function fade() {
    let val = parseFloat(newElm.style.opacity);
    if (!((val += 0.1) > 1)) {
      newElm.style.opacity = val;
      setTimeout(fade, 0);
    } else {
      oldEl.parentNode.removeChild(oldEl);
    }
  })();
}
</script>

<style lang="less" scoped>
.lazy-img {
  position: relative;
  z-index: 0;
  margin: 0 auto;

  .padding {
    background: rgb(244, 244, 244);
    height: calc(~"(420 / 750) * 100vw"); // 默认为 banner 的宽高比
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .lazy-img-wrap {
    height: calc(~"(420 / 750) * 100vw"); // 默认为 banner 的宽高比
    width: 100%;
    background: rgb(244, 244, 244);
    overflow: hidden;
    top: 0;
    opacity: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .target-img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 50%;
      border-radius: inherit;
      transform: translateY(-50%);

      object-fit: contain;
    }
  }

  .glass-effect-img-wrapper {
    position: absolute;
    z-index: -1;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    overflow: hidden;

    .glass-effect-img {
      width: 100%;
      height: 100%;

      object-fit: cover;
      filter: blur(4px);
      opacity: 0.5;

      border-radius: inherit;
    }
  }
}
</style>
